import { useAuth } from 'contexts/ProtectedRoute';
import { Role } from 'data/constants/roles';

const OWNER_ROLES: string[] = [
    Role.SUPER_SUPER_ADMIN,
    Role.SUPER_ADMIN,
    Role.ADMIN,
    Role.BACKOFFICE_ADMIN,
];

/**
 * Returns whether the current user has an owner (admin) role.
 */
export const useIsOwnerRole = () => {
    const { role } = useAuth();
    const isOwner = OWNER_ROLES.includes(role);
    return { isOwner };
};
